export type SalonService = {
  id: string;
  title: string;
  summary: string;
  accent: string;
  image: string;
  imageAlt: string;
};

export type SalonHeroSlide = {
  id: string;
  image: string;
  alt: string;
};

const address =
  'Beşevler Mahallesi Beşevler Caddesi Tüzüner Sitesi No: 159/B Nilüfer/Bursa';
const encodedAddress = encodeURIComponent(address);

export const salon = {
  brand: 'Çağla Karagiray',
  tagline: 'The Most Beauty',
  shortName: 'The Most Beauty',
  phone: '0544 686 1816',
  phoneHref: 'tel:+905446861816',
  whatsappHref: 'https://wa.me/905446861816',
  instagramHandle: '@caglakaragiray',
  instagramHref: 'https://www.instagram.com/caglakaragiray/',
  address,
  mapsHref: `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`,
  mapsEmbedHref: `https://www.google.com/maps?q=${encodedAddress}&output=embed`,
  heroImage:
    'https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?auto=format&fit=crop&w=1200&q=85',
};

export const salonHeroSlides: SalonHeroSlide[] = [
  {
    id: 'kalici-makyaj',
    image: '/salon-slider/slide-01-kalici-makyaj.png',
    alt: 'Kalıcı makyaj hizmeti',
  },
  {
    id: 'protez-tirnak',
    image: '/salon-slider/slide-02-protez-tirnak.png',
    alt: 'Protez tırnak hizmeti',
  },
  {
    id: 'ipek-kirpik',
    image: '/salon-slider/slide-03-ipek-kirpik.png',
    alt: 'İpek kirpik hizmeti',
  },
  {
    id: 'pedikur',
    image: '/salon-slider/slide-04-pedikur.png',
    alt: 'Pedikür hizmeti',
  },
  {
    id: 'kalici-oje',
    image: '/salon-slider/slide-05-kalici-oje.png',
    alt: 'Kalıcı oje hizmeti',
  },
  {
    id: 'manikur',
    image: '/salon-slider/slide-06-manikur.png',
    alt: 'Manikür hizmeti',
  },
  {
    id: 'epilasyon',
    image: '/salon-slider/slide-07-epilasyon.png',
    alt: 'Epilasyon hizmeti',
  },
  {
    id: 'cilt-bakimi',
    image: '/salon-slider/slide-08-cilt-bakimi.png',
    alt: 'Cilt bakımı hizmeti',
  },
  {
    id: 'cilt-yenileme',
    image: '/salon-slider/slide-09-cilt-yenileme.png',
    alt: 'Cilt yenileme işlemleri',
  },
  {
    id: 'altin-oran-kas',
    image: '/salon-slider/slide-10-altin-oran-kas.png',
    alt: 'Altın oran kaş tasarımı',
  },
];

export const salonServices: SalonService[] = [
  {
    id: 'cilt-bakimi',
    title: 'Cilt Bakımı',
    summary: 'Cildin ihtiyacına göre arındırma, nem ve bakım odaklı uygulamalar.',
    accent: 'Bakım',
    image: '/service-images/cilt-bakimi.png',
    imageAlt: 'Cilt bakımı uygulaması',
  },
  {
    id: 'cilt-yenileme',
    title: 'Cilt Yenileme İşlemleri',
    summary: 'Daha canlı, dengeli ve taze bir cilt görünümünü destekleyen işlemler.',
    accent: 'Yenileme',
    image: '/service-images/cilt-yenileme-islemleri.png',
    imageAlt: 'Cilt yenileme işlemleri uygulaması',
  },
  {
    id: 'altin-oran-kas',
    title: 'Altın Oran Kaş Tasarımı',
    summary: 'Yüz formuna uyumlu, ölçülü ve doğal kaş tasarımı.',
    accent: 'Kaş',
    image: '/service-images/altin-oran-kas-tasarimi.png',
    imageAlt: 'Altın oran kaş tasarımı uygulaması',
  },
  {
    id: 'epilasyon',
    title: 'Epilasyon',
    summary: 'Konforlu ve planlı epilasyon hizmetleri.',
    accent: 'Pürüzsüzlük',
    image: '/service-images/epilasyon.png',
    imageAlt: 'Epilasyon uygulaması',
  },
  {
    id: 'depilasyon',
    title: 'Depilasyon (Ağda)',
    summary: 'Hijyenik, hızlı ve özenli ağda uygulamaları.',
    accent: 'Ağda',
    image: '/service-images/epilasyon.png',
    imageAlt: 'Depilasyon ve ağda uygulaması',
  },
  {
    id: 'ipek-kirpik',
    title: 'İpek Kirpik',
    summary: 'Bakışları belirginleştiren doğal ve zarif kirpik uygulaması.',
    accent: 'Kirpik',
    image: '/service-images/ipek-kirpik.png',
    imageAlt: 'İpek kirpik uygulaması',
  },
  {
    id: 'manikur',
    title: 'Manikür',
    summary: 'El ve tırnak görünümünü tamamlayan bakım rutini.',
    accent: 'El Bakımı',
    image: '/service-images/manikur.png',
    imageAlt: 'Manikür uygulaması',
  },
  {
    id: 'pedikur',
    title: 'Pedikür',
    summary: 'Ayak bakımında temiz, rahat ve bakımlı sonuçlar.',
    accent: 'Ayak Bakımı',
    image: '/service-images/pedikur.png',
    imageAlt: 'Pedikür uygulaması',
  },
  {
    id: 'kalici-oje',
    title: 'Kalıcı Oje',
    summary: 'Parlaklığını koruyan, bakımlı ve uzun süreli oje görünümü.',
    accent: 'Oje',
    image: '/service-images/kalici-oje.png',
    imageAlt: 'Kalıcı oje uygulaması',
  },
  {
    id: 'protez-tirnak',
    title: 'Protez Tırnak',
    summary: 'Formu dengeli, estetik ve kişiye özel tırnak tasarımları.',
    accent: 'Tırnak',
    image: '/service-images/protez-tirnak.png',
    imageAlt: 'Protez tırnak uygulaması',
  },
  {
    id: 'kalici-makyaj',
    title: 'Kalıcı Makyaj',
    summary: 'Günlük görünümü kolaylaştıran, yüz hatlarına uyumlu uygulamalar.',
    accent: 'Makyaj',
    image: '/service-images/kalici-makyaj.png',
    imageAlt: 'Kalıcı makyaj uygulaması',
  },
];
